<template>
  <v-dialog width="85%" persistent v-model="isShow">
    <EventViewer :isShow="isEventShow" :event="selectedEvent" @close="isEventShow=false"></EventViewer>
    <v-card>
      <v-toolbar color="primary" dark dense >
        <v-toolbar-title style="font-size: 18px">{{ title.replace('#',' & ') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close">mdi-close</v-icon>
      </v-toolbar>
      <v-toolbar flat height="80%">
        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
          Today
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small> mdi-chevron-right </v-icon>
        </v-btn>
        
       <v-toolbar-title class="ml-2">
          {{ calTitle }}
        </v-toolbar-title> 
        
        <v-spacer></v-spacer>
      
       </v-toolbar>
      <div>
        <span v-for="(item, idx) in selectedCalendars" :key="item.identity">
        <v-chip :color="colors[idx % 6]" class="mr-2 mb-2" small dark> {{item.name}}</v-chip></span>
      </div>
      <v-card-text>
        <v-calendar
          style="min-height:600px"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :type="type"
          locale="en-us"
          @click:event="viewEvent"
          @click:more="viewDay"
          @click:date="viewDay"
        ></v-calendar>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import EventViewer from './EventViewer.vue';

export default {
  name: "CalendarViewModal",
  components: { EventViewer },
  props: { isShow: Boolean, calendar: Object, selectedCalendars:Array },
  data: () => {
    return {
      focus: "2022-09-04",
      title: "View ",
      type: "month",
      events: [],
      colors: [
        "#b73e3e",
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      selectedEvent: {name:'', description: ''},
      isEventShow: false
    };
  },
  computed:{
    calTitle(){
      return moment(this.focus).format("MMM yyyy")
    }
  },
  methods: {
    viewEvent({ nativeEvent, event }){
      console.log(event)
      this.selectedEvent = event;
      this.isEventShow = true;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    close() {
      this.type = "month";
      this.$emit("close", "close");
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.type = "month";
      this.focus = moment();
    },
    prev() {
      this.type = "month";
      this.$refs.calendar.prev();
    },
    next() {
      this.type = "month";
      this.$refs.calendar.next();
    },
    refreshEvents() {
      this.focus = moment().format('yyyy-MM-DD')
      this.events = [];
      if (this.calendar && this.calendar.events.length > 0) {
        this.calendar.events.forEach((e) => {
          let _event = {
            name: e.name,
            description: e.description,
            start: moment(e.startDateTime).format("YYYY-MM-DD"),
            end: moment(e.endDateTime).format("YYYY-MM-DD"),
            color: e.color ? this.colors[e.color] : "#b73e3e",
            timed: false,
          };
          if (e.index) _event.color = this.colors[e.index % 6];
          this.events.push(_event);
        });
        //this.focus = moment(this.events[0].start).format("yyyy-MM-DD");
      }
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getColor(idx){
      console.log(idx)
      return this.colors[idx % 6];
    }
  },
  mounted() {
    //this.refreshEvents();
  },
  watch: {
    calendar: {
      handler() {       
        if (this.calendar) {
          this.title = "View " + this.calendar.name;
          this.refreshEvents();
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.pl-1 {
  font-size: 14px;
}
</style>